import React from 'react';

import { RetryQueryAlert } from 'src/components/alerts/RetryQueryAlert';
import { Card } from 'src/components/ui/card';
import { ForecastChart } from 'src/features/forecast/ForecastChart';
import { ForecastLegend } from 'src/features/forecast/ForecastLegend';
import { useForecast } from 'src/features/forecast/hooks/useForecast';
import { ForecastPaginatedProductDetailsContainer } from 'src/features/forecastPaginated/forecastPaginatedDetails/ForecastPaginatedProductDetailsContainer';
import { ForecastPaginatedTableContainer } from 'src/features/forecastPaginated/forecastPaginatedTable/ForecastPaginatedTableContainer';
import { QUERY_KEY_SKU_FORECAST_DATA } from 'src/keys';
import { useSkuDetailQuery } from 'src/services/api/getSkuDetail';

type ForecastProps = {
  sku: string;
};

export function Forecast({ sku }: ForecastProps) {
  const { data, isLoading, error } = useForecast(sku);
  const { data: skuDetail } = useSkuDetailQuery(sku);

  return (
    <>
      {error ? (
        <div className='flex items-center justify-center p-4'>
          <RetryQueryAlert
            queryKey={[QUERY_KEY_SKU_FORECAST_DATA, sku]}
            isLoading={isLoading}
          />
        </div>
      ) : (
        <div className='flex h-[calc(100vh-65px)] w-full flex-col overflow-y-auto overflow-x-hidden p-6'>
          <div className='flex w-full'>
            <ForecastPaginatedProductDetailsContainer sku={sku} fullWidth />
          </div>
          <Card className='relative mt-4 w-full'>
            <ForecastChart
              data={data || []}
              isNovelty={skuDetail?.is_novelty}
              className='z-10 -ml-12 mb-6 mt-4 h-[32rem] w-[115%] md:mb-0 md:w-[110%] lg:-mb-4 lg:-ml-16'
            />
            <ForecastLegend className='bottom-4 left-4 right-4' />
          </Card>
          <Card className='mt-4'>
            <div className='max-h-fit overflow-auto'>
              <ForecastPaginatedTableContainer
                sku={sku}
                data={data || []}
                isLoading={isLoading}
                editable={false}
              />
            </div>
          </Card>
        </div>
      )}
    </>
  );
}
